<mat-drawer-container class="container" autosize>
  <mat-drawer #productDetails class="sidenav" mode="over" position="end" [opened]="isDrawerOpen" (closed)="onProductDetailsClose()">

    <div *ngIf="selectedProducts.length <= 1" #modelContainer class="w-100 p-20" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
      <h3>Product Preview</h3>

      <div class="image-preview">
        <model-viewer [fxShow]="url" id="glb"
          [style.height.px]="productWidth" [style.width.px]="productWidth"
          shadow-intensity="1" camera-controls touch-action="pan-y"
          [src]="url"
          [poster]="posterUrl"
          data-js-focus-visible=""
          ar-status="not-presenting"
          min-camera-orbit="auto auto 10%" max-camera-orbit="auto auto 100%"
          min-field-of-view="45deg" max-field-of-view="90deg"
          camera-orbit="225deg 55deg auto"
          environment-image="https://cdn.situsystems.com/products/small_empty_room_3_4k.jpg"
          environment-image-intensity="0.35"
          alt="Model preview"
          tone-mapping="aces">
        </model-viewer>

        <div *ngIf="!url" fxLayout="column" fxLayoutAlign="center center">
          <img src="/assets/images/no-image-icon.svg" class="no-image-preview">
        </div>
      </div>

      <img class="company-logo" *ngIf="getCompanyLogo(selectedProducts[0]?.companyId)" [src]="getCompanyLogo(selectedProducts[0]?.companyId)" alt="">
      <small *ngIf="!getCompanyLogo(selectedProducts[0]?.companyId)">{{ getCompanyName(selectedProducts[0]?.companyId ?? selectedProducts[0]?.supplierId) }}</small>
      <div class="product-type">{{ selectedProducts[0]?.name }}</div>
      <button mat-flat-button color="accent" (click)="selectProduct()">Select Product</button>
    </div>

    <div *ngIf="selectedProducts.length > 1">
      <div class="w-100 p-20" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <h3>Selected Products</h3>
      </div>
      <div class="p-20">
        <div *ngFor="let item of selectedProducts">
          <b>{{ getCompanyName(item.companyId) }}</b> - {{ item.name }}
        </div>
      </div>
      <div class="w-100 p-20" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px">
        <button mat-flat-button color="accent" (click)="selectProduct()">Confirm Product Selection</button>
      </div>
    </div>

  </mat-drawer>
  <div class="sidenav-content">
    <product-catalog-list
      [companyIdFilter]="data.companyId"
      [productClassificationIdFilter]="data.classificationId"
      [productTypeIdFilter]="data.productTypeId"
      [productSpecificationSelectedIds]="seedSpecificationIds"
      (onFilterCompanyId)="onFilterCompanyId($event)"
      (onFilterProductClassificationId)="onFilterClassificationId($event)"
      (onFilterProductTypeId)="onFilterProductTypeId($event)"
      (onProductSelected)="onProductSelected($event)"
      [multiSelect]="data.multiSelect ?? false"
      [allowRequestedProducts]="false">
    </product-catalog-list>
  </div>
</mat-drawer-container>
